import { didCancel } from 'ember-concurrency';

export function ignoreCancelation(error) {
  if (!didCancel(error)) {
    throw error;
  }
}
